import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { userLoginChallengeThunk, userLoginThunk, userSwitchTenantThunk } from "./thunk";

import { RootState } from "slices/store";
import { User } from '../../../models/user/user'
import { APIResult } from "models/api-results";
import { TenantType } from "models/enums";

export interface AuthState {

    loggedInuser?: User,
    loading: boolean;
    sessionToken?: string;//used for otp validation
    token?: string;
    error?: string;
    success: boolean;
    /*    success: boolean;
       isUserLogout: boolean;
       user: string; */
}

export const initialState: AuthState = {
    loggedInuser: undefined,
    loading: false,
    sessionToken: "",
    token: "",
    error: "",
    success: false

};

const loginSlice = createSlice({
    name: "login",
    initialState,
    reducers: {
        logout(state: AuthState, action: PayloadAction) {
            state.loading = false;
            state.error = '';
            state.success = false;
            state.loggedInuser = undefined;
            state.sessionToken = '';
            state.token = '';
        },
        resetMessages(state: AuthState, action: PayloadAction) {
            state.error = '';
            state.success = false;
        }
    },
    extraReducers: (builder) => {
        //Login
        builder.addCase(userLoginThunk.pending, (state) => {
            state.loading = true;
            state.error = "";
            //console.log('State after userLoginThunk.pending:', state.loggedInuser);
        });
        builder.addCase(userLoginThunk.fulfilled, (state, action) => {
            state.loading = false;
            const _apiData: APIResult<User | null> = action.payload
            state.loggedInuser = _apiData.data ?? undefined
            if (state.loggedInuser) {
                state.loggedInuser.tenants = state.loggedInuser.tenants?.filter((t) => t.tenantTypeId != TenantType.SYSTEM &&
                    (!state.loggedInuser?.activeTenantId || t.id == state.loggedInuser.activeTenantId))
            }
            if ((action.payload?.status?.isError ?? false)) {
                state.error = _apiData?.status?.errorMessage ?? "Login failed"
            } else {
                state.token = _apiData?.meta?.token ?? "";
                state.sessionToken = _apiData?.meta?.sessionToken ?? "";

            }
            // console.log('State after userLoginThunk.fulfilled:', state.loggedInuser);
        });
        /*  builder.addCase(userLoginThunk.rejected, (state) => {
             state.loading = false;
         }); */
        //Login with 2 f actor
        builder.addCase(userLoginChallengeThunk.pending, (state) => {
            state.loading = true;
            state.error = ""
            // console.log('State after LoginChallengeThunk.pending:', state.loggedInuser);
        });
        builder.addCase(userLoginChallengeThunk.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload) {
                const _apiData: APIResult<User | null> = action.payload;

                if ((action.payload?.status?.isError ?? false)) {
                    state.error = _apiData?.status?.errorMessage ?? "Login failed"
                } else {
                    state.token = _apiData?.meta?.token ?? "";
                    state.sessionToken = _apiData?.meta?.sessionToken ?? "";

                    state.loggedInuser = _apiData.data ?? undefined
                    if (state.loggedInuser) {
                        state.loggedInuser.tenants = state.loggedInuser.tenants?.filter((t) => t.tenantTypeId != TenantType.SYSTEM &&
                            (!state.loggedInuser?.activeTenantId || t.id == state.loggedInuser.activeTenantId))
                    }
                }
            } else {
                state.error = "Something went wrong..."
            }
            // console.log('State after LoginChallengeThunk.fulfilled:', state.loggedInuser);

        });
        builder.addCase(userLoginChallengeThunk.rejected, (state) => {
            state.loading = false;
        });

        //switch tenant
        builder.addCase(userSwitchTenantThunk.pending, (state) => {
            state.loading = true;
            state.error = "";
            // console.log('State after userSwitchTenantThunk.pending:', state.loggedInuser);
        });
        builder.addCase(userSwitchTenantThunk.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload) {
                const _apiData: APIResult<User | null> = action.payload;
                console.log(_apiData)
                if ((action.payload?.status?.isError ?? false)) {
                    state.error = _apiData?.status?.errorMessage ?? "Login failed"
                } else {
                    state.token = _apiData?.meta?.token ?? "";
                    state.sessionToken = _apiData?.meta?.sessionToken ?? "";
                    state.loggedInuser = _apiData.data ?? undefined;
                    if (state.loggedInuser) {
                        state.loggedInuser.tenants = state.loggedInuser.tenants?.filter((t) => t.tenantTypeId != TenantType.SYSTEM &&
                            (!state.loggedInuser?.activeTenantId || t.id == state.loggedInuser.activeTenantId))
                    }
                }
            } else {
                state.error = "Something went wrong...";
            }
            //console.log('State after userSwitchTenantThunk.fulfilled:', state.loggedInuser);

        });
        builder.addCase(userSwitchTenantThunk.rejected, (state) => {
            state.loading = false;
        });

    }
});

export const { logout, resetMessages } = loginSlice.actions;
export default loginSlice.reducer;
export const getAuthState = (store: RootState): AuthState => store.auth;
